export default {
  name: 'Nombre',
  actions: 'Acciones',
  'list.entities.name_pending': 'Tipos de pendencias',
  'list.entities.name_serviceTransport': 'Tipos de transporte',
  'list.entities.name_rescheduling': 'Motivos de reagendamiento',
  'list.entities.name_approved': 'Motivos de aprobación',
  'list.entities.name_disapproved': 'Motivos de rechazo',
  'list.entities.name_unproductive': 'Motivos de improductividad',
  'list.entities.name_canceled': 'Motivos de cancelación',
  'list.entities.name_checkListCategory': 'Categorías de los cuestionarios',
  'list.entities.name_assetType': 'Tipos de activos',
  'list.entities.name_pause': 'Motivos de pausa',
  'list.entities.name_closing': 'Motivos de cierre',

  title_modal_pending_edit: 'Editar Tipo de pendencia',
  title_modal_serviceTransport_edit: 'Editar Tipo de transporte',
  title_modal_rescheduling_edit: 'Editar Motivo de reagendamiento',
  title_modal_approved_edit: 'Editar Motivo de aprobación',
  title_modal_disapproved_edit: 'Editar Motivo de rechazo',
  title_modal_unproductive_edit: 'Editar Motivo de improductividad',
  title_modal_canceled_edit: 'Editar Motivo de cancelación',
  title_modal_checkListCategory_edit: `Editar Categorías de los cuestionarios`,
  title_modal_assetType_edit: `Editar Tipo de activo`,
  title_modal_closing_edit: `Editar Motivo de cierre`,

  title_modal_pending: 'Nuevo Tipo de pendencia',
  title_modal_serviceTransport: 'Nuevo Tipo de transporte',
  title_modal_rescheduling: 'Nuevo Motivo de reagendamiento',
  title_modal_approved: 'Nuevo Motivo de aprobación',
  title_modal_disapproved: 'Nuevo Motivo de rechazo',
  title_modal_unproductive: 'Nuevo Motivo de improductividad',
  title_modal_canceled: 'Nuevo Motivo de cancelación',
  title_modal_checkListCategory: `Nueva Categorías de los cuestionarios`,
  title_modal_assetType: 'Nuevo Tipo de activo',
  title_modal_closing: 'Nuevo Motivo de cierre',
  selectCategories: 'Selección de categorías'
}
